import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getProvinces } from 'commons/js/api'
import { reportClaim } from '../../../api'
import Form from './Form'
import Success from '../../Success'
import Error from '../../Error'
import { Loader } from '../../../ui'
import { FormattedMessage } from 'react-intl'
import useApi from 'commons/js/hooks/useApi'

const Wrapper = ({ fine, onBack, onSuccess, town, getProvinces, brandId, reportClaim }) => {
    const [form, setForm] = useState(null)
    const {
        response: { result: claim, error },
        loading,
        sendRequest: createClaim,
    } = useApi(reportClaim)

    useEffect(() => {
        if (!form) {
            return
        }

        createClaim({
            bulletinNumber: fine.bulletinNumber,
            townId: town.id,
            claim: form,
            brandId,
        })
    }, [form, fine, town, createClaim, brandId])

    if (error) {
        return (<Error id={error} onBack={() => { onBack(fine) }} />)
    }

    if (claim) {
        return (<Success
          onBack={() => onSuccess()}
          message={<FormattedMessage defaultMessage='Reclamación enviada correctamente' />} />)
    }

    if (loading) {
        return (<Loader>
            <FormattedMessage defaultMessage='Un momento, por favor...' />
        </Loader>)
    }

    return (
        <Form
          fine={fine}
          onBack={() => onBack(fine)}
          getProvinces={getProvinces}
          onSubmit={setForm}
        />
    )
}

Wrapper.propTypes = {
    fine: PropTypes.shape({
        bulletinNumber: PropTypes.string,
        claims: PropTypes.array,
    }).isRequired,
    town: PropTypes.shape({
        id: PropTypes.number,
    }).isRequired,
    onBack: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    getProvinces: PropTypes.func.isRequired,
    reportClaim: PropTypes.func.isRequired,
    brandId: PropTypes.number.isRequired,
}

Wrapper.defaultProps = {
    getProvinces,
    reportClaim,
}

export default Wrapper
